<template>
  <BasicAlert
    v-if="warningVisible"
    alertType="warning"
    :alertLabel="warningMessage"
  />
</template>

<script setup lang="ts">
  import { ref, watch } from 'vue'
  import { validateRncpHabilitations } from '@/features/services/demande/DemandeAllService'
  import type { LovItemDTO } from '@/features/api/extranet/dto/Lov'
  import {
    MSG_WARNING_HABILITATION_CFA_RNCP,
    MSG_WARNING_HABILITATION_LIEU_FORMATION_RNCP,
  } from '@/features/interface/demande/shared/language'

  const warningVisible = ref(false)
  const warningMessage = ref('')

  const props = defineProps<{
    rncp: LovItemDTO<string> | null | undefined
    cfaSiret: string | null | undefined
    lieuFormationSiret: string | null | undefined
    readonly?: boolean
  }>()

  watch(
    () => ({
      rncp: props.rncp?.code,
      cfaSiret: props.cfaSiret,
      lieuFormationSiret: props.lieuFormationSiret,
      readonly: props.readonly,
    }),
    async () => {
      if (props.readonly || !props.rncp?.code || !props.cfaSiret) {
        warningVisible.value = false
        return
      }

      // Vérifier CFA responsable
      const habilitationsCfa = await validateRncpHabilitations(props.cfaSiret, props.rncp.code)

      // Si enregistrement de droit → pas de contrôle
      if (habilitationsCfa.includes('DeDroit')) {
        warningVisible.value = false
        return
      }

      // Si CFA responsable n'a pas l'habilitation Former
      if (!habilitationsCfa.includes('Former')) {
        warningMessage.value = MSG_WARNING_HABILITATION_CFA_RNCP
        warningVisible.value = true
        return
      }

      // Si lieu de formation différent du CFA → vérifier aussi le lieu
      if (props.lieuFormationSiret && props.lieuFormationSiret !== props.cfaSiret) {
        const habilitationsLieu = await validateRncpHabilitations(props.lieuFormationSiret, props.rncp.code)

        if (!habilitationsLieu.includes('DeDroit') && !habilitationsLieu.includes('Former')) {
          warningMessage.value = MSG_WARNING_HABILITATION_LIEU_FORMATION_RNCP
          warningVisible.value = true
          return
        }
      }

      warningVisible.value = false
    },
    { immediate: true },
  )
</script>
